import styled from "styled-components";

// full screen container
export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  // gradient background
  background: linear-gradient(180deg, #ffe787 0%, #ffcc02 100%);
`;

export const LoginBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-radius: 8px;
  background: #fff;
  padding: 40px;
  width: 100%;
  max-width: 400px;
  margin: 1rem;
  gap: 5px;

  /* Box */
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.25);
  & > img {
    height: 80px;
    margin-bottom: 20px;
  }
`;
